import { c as _c } from "react/compiler-runtime";
import Image from '@/components/media/StorefrontImage';
import Link from 'next/link';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
export interface ProductCardProduct {
  id: number;
  name: string;
  slug: string;
  basePrice: string;
  specialPrice: string | null;
  mainImage?: {
    url: string;
    altText: string | null;
  } | null;
}
export function formatPrice(price: string): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(parseFloat(price));
}
export function ProductCard(t0) {
  const $ = _c(15);
  const {
    product
  } = t0;
  const t1 = `/${product.slug}`;
  let t2;
  if ($[0] !== product.mainImage || $[1] !== product.name) {
    t2 = <CardContent className="p-4"><div className="relative aspect-[4/3] bg-white">{product.mainImage ? <Image src={product.mainImage.url} alt={product.mainImage.altText || product.name} fill={true} sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw" className="object-contain" /> : <span className="flex h-full w-full items-center justify-center text-3xl text-muted-foreground/50">📷</span>}</div></CardContent>;
    $[0] = product.mainImage;
    $[1] = product.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== product.name) {
    t3 = <CardHeader className="px-4 pb-2 pt-0"><CardTitle className="line-clamp-3 text-sm sm:text-base leading-tight text-[#5b86b7] underline">{product.name}</CardTitle></CardHeader>;
    $[3] = product.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== product.basePrice || $[6] !== product.specialPrice) {
    t4 = <CardFooter className="flex flex-col items-start gap-1 px-4 pb-4 pt-0"><div className="flex items-baseline gap-2">{product.specialPrice ? <><span className="text-base font-semibold text-green-600">{formatPrice(product.specialPrice)}</span><span className="text-xs text-muted-foreground line-through">{formatPrice(product.basePrice)}</span></> : <span className="text-base font-semibold text-green-600">{formatPrice(product.basePrice)}</span>}</div></CardFooter>;
    $[5] = product.basePrice;
    $[6] = product.specialPrice;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <Card className="h-full rounded-none border border-slate-200 bg-white shadow-none">{t2}{t3}{t4}</Card>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <Link href={t1} className="block">{t5}</Link>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}